import React from 'react';
import PropTypes from 'prop-types';
import { Button, Flex } from 'nallian-shared-ui/lib/components';
import { BackButton } from 'nallian-shared-ui/lib/modules';

const FormActions = ({ onClickSave, processingForm, asyncValidating }) => (
  <Flex margin="1rem 0 0" justifyContent="flex-end">
    <BackButton route="/organisations" text="Cancel" margintop="0" />
    <Button
      btnprimary
      onClick={onClickSave}
      disabled={processingForm || asyncValidating}
      loading={processingForm}
      icon="save"
      content="Save"
    />
  </Flex>
);

FormActions.propTypes = {
  onClickSave: PropTypes.func.isRequired,
  processingForm: PropTypes.bool.isRequired,
  asyncValidating: PropTypes.bool,
};

FormActions.defaultProps = { asyncValidating: false };

export default FormActions;
